/**
 * Serviço para operações relacionadas a criação de Ordens de Serviço
 */

// Desenvolvimento: localhost:3002. Produção: mesma origem (Apache proxy encaminha /api)
const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3002';
  }
  return window.location.origin;
};

const API_BASE_URL = getApiBaseUrl();

/**
 * Busca o código de status baseado no tipo de programação e tipo de OS
 * @param {string} scheduleType - Tipo de programação ('today', 'tomorrow', 'future', ou null)
 * @param {string} osType - Tipo de OS ('contrato' ou 'estoque')
 * @param {string} tipoOs - Tipo específico de OS ('C'=Corretiva, 'S'=Preventiva, 'A'=Aferição, 'D'=Desinstalação)
 * @returns {Promise<{success: boolean, codStatus: string}>}
 */
export const getStatusCode = async (scheduleType, osType = 'contrato', tipoOs = null) => {
  try {
    const token = localStorage.getItem('authToken');
    let endpoint = '/api/os/status'; // Endpoint base
    const params = [];
    
    // Adicionar parâmetro type se necessário
    if (scheduleType) {
      params.push(`type=${scheduleType}`);
    }
    
    // Adicionar parâmetro osType
    if (osType) {
      params.push(`osType=${osType}`);
    }
    
    // Adicionar parâmetro tipoOs se necessário
    if (tipoOs) {
      params.push(`tipoOs=${tipoOs}`);
    }
    
    if (params.length > 0) {
      endpoint += `?${params.join('&')}`;
    }
    
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error('Erro ao buscar código de status');
    }
    
    const data = await response.json();
    return {
      success: true,
      codStatus: data.codStatus || data.status || null
    };
  } catch (error) {
    console.error('Erro ao buscar código de status:', error);
    return {
      success: false,
      codStatus: null,
      error: error.message
    };
  }
};

/**
 * Cria uma nova Ordem de Serviço executando a stored procedure SP_LCMY_GOS
 * @param {object} osData - Dados da OS
 * @returns {Promise<{success: boolean, osNumber?: string, errors?: Array}>}
 */
export const createOS = async (osData) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/api/os/create`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(osData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Erro ao criar ordem de serviço');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao criar OS:', error);
    return {
      success: false,
      errors: [{
        ErrorMessage: error.message || 'Erro desconhecido ao criar ordem de serviço'
      }]
    };
  }
};

/**
 * Envia email da OS usando configuração do sistema (LCMY_SYS_CONFIG)
 */
export const sendOSEmailSystem = async (to, subject, html, empresaCodigo) => {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${API_BASE_URL}/api/os/send-email-system`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ to, subject, html, empresaCodigo: empresaCodigo || undefined })
  });
  const j = await res.json();
  return j;
};

/** Orya: escreve/refina observações da OS e do agendamento. Retorna `{ content }`. */
export const aiWriteOsNote = async ({ prompt, draft, history }) => {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${API_BASE_URL}/api/os/ai-write`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt, draft, history }),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || j.success === false) {
    throw new Error(j.message || `Erro ${res.status}`);
  }
  return j.data;
};

